(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    (function () {
    const notif = document.querySelector('[data-cart-notification]');
    if (!notif) return;

    const panel = notif.querySelector('.ax-cn__panel');
    const imgEl = notif.querySelector('[data-cn-image]');
    const titleEl = notif.querySelector('[data-cn-title]');
    const variantEl = notif.querySelector('[data-cn-variant]');
    const viewEl = notif.querySelector('[data-cn-view]');
    const viewLabel = viewEl.textContent.trim();

    function open() {
      notif.hidden = false;
      requestAnimationFrame(() => notif.classList.add('is-open'));
      panel.focus();
    }
    function close() {
      notif.classList.remove('is-open');
    }
    panel.addEventListener('transitionend', () => {
      if (!notif.classList.contains('is-open')) notif.hidden = true;
    });

    notif.querySelectorAll('[data-cn-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    document.addEventListener('click', (e) => {
      if (!notif.classList.contains('is-open')) return;
      if (panel.contains(e.target)) return;
      if (e.target.closest('form[action$="/cart/add"]')) return;
      close();
    });

    function setBadge(count) {
      const link = document.querySelector('a[href$="/cart"]');
      if (!link) return;
      let badge = link.querySelector('.ax-icon-btn__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ax-icon-btn__badge';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    function resize(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    async function addToCart(form) {
      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) { form.submit(); return; }
        const item = await res.json();
        const cart = await (await fetch('/cart.js')).json();

        const src = (item.featured_image && item.featured_image.url) || item.image;
        if (src) { imgEl.src = resize(src, 160); imgEl.hidden = false; } else { imgEl.hidden = true; }
        titleEl.textContent = item.product_title || item.title;
        const vt = item.variant_title;
        variantEl.textContent = vt && vt !== 'Default Title' ? vt : '';
        viewEl.textContent = viewLabel + ' (' + cart.item_count + ')';
        setBadge(cart.item_count);
        open();
      } catch (e) {
        form.submit();
      } finally {
        if (btn) btn.removeAttribute('aria-busy');
      }
    }

    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action$="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facet-categories"] && !Shopify.designMode) return;
  try {
    (function () {
    const KEY = 'ax-facets-state';
    const read = () => {
      try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
    };
    const write = (s) => {
      try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    };

    document.querySelectorAll('.ax-cat[data-cat-key]').forEach((li) => {
      const kids = li.querySelector(':scope > .ax-cat__children');
      const btn = li.querySelector(':scope > .ax-cat__row > .ax-cat__toggle');
      if (!kids || !btn) return;

      const stateKey = 'cat:' + li.dataset.catKey;

      // Restore the saved expand/collapse state (overrides the server default).
      const saved = read();
      if (stateKey in saved) {
        kids.hidden = !saved[stateKey];
        btn.setAttribute('aria-expanded', saved[stateKey] ? 'true' : 'false');
      }

      btn.addEventListener('click', () => {
        const willOpen = kids.hidden;
        kids.hidden = !willOpen;
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        const s = read();
        s[stateKey] = willOpen;
        write(s);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
